// Medicine
const MEDICINE_PREFIX = 'MEDICINE_'
export const MEDICINE = {
  LIST_REQUEST: `${MEDICINE_PREFIX}LIST_REQUEST`,
  LIST_SUCCESS: `${MEDICINE_PREFIX}LIST_SUCCESS`,
  LIST_FAILURE: `${MEDICINE_PREFIX}LIST_FAILURE`,
  CREATE_REQUEST: `${MEDICINE_PREFIX}CREATE_REQUEST`,
  CREATE_SUCCESS: `${MEDICINE_PREFIX}CREATE_SUCCESS`,
  CREATE_FAILURE: `${MEDICINE_PREFIX}CREATE_FAILURE`,
  UPDATE_REQUEST: `${MEDICINE_PREFIX}UPDATE_REQUEST`,
  UPDATE_SUCCESS: `${MEDICINE_PREFIX}UPDATE_SUCCESS`,
  UPDATE_FAILURE: `${MEDICINE_PREFIX}UPDATE_FAILURE`,
  DELETE_REQUEST: `${MEDICINE_PREFIX}DELETE_REQUEST`,
  DELETE_SUCCESS: `${MEDICINE_PREFIX}DELETE_SUCCESS`,
  DELETE_FAILURE: `${MEDICINE_PREFIX}DELETE_FAILURE`,
  CLEAR_NOTIFY: `${MEDICINE_PREFIX}CLEAR_NOTIFY`
}

// Medicine Types
const MEDICINE_TYPE_PREFIX = 'MEDICINE_TYPE_'
export const MEDICINE_TYPE = {
  LIST_REQUEST: `${MEDICINE_TYPE_PREFIX}LIST_REQUEST`,
  LIST_SUCCESS: `${MEDICINE_TYPE_PREFIX}LIST_SUCCESS`,
  LIST_FAILURE: `${MEDICINE_TYPE_PREFIX}LIST_FAILURE`,
  CREATE_REQUEST: `${MEDICINE_TYPE_PREFIX}CREATE_REQUEST`,
  CREATE_SUCCESS: `${MEDICINE_TYPE_PREFIX}CREATE_SUCCESS`,
  CREATE_FAILURE: `${MEDICINE_TYPE_PREFIX}CREATE_FAILURE`,
  UPDATE_REQUEST: `${MEDICINE_TYPE_PREFIX}UPDATE_REQUEST`,
  UPDATE_SUCCESS: `${MEDICINE_TYPE_PREFIX}UPDATE_SUCCESS`,
  UPDATE_FAILURE: `${MEDICINE_TYPE_PREFIX}UPDATE_FAILURE`,
  DELETE_REQUEST: `${MEDICINE_TYPE_PREFIX}DELETE_REQUEST`,
  DELETE_SUCCESS: `${MEDICINE_TYPE_PREFIX}DELETE_SUCCESS`,
  DELETE_FAILURE: `${MEDICINE_TYPE_PREFIX}DELETE_FAILURE`,
  CLEAR_NOTIFY: `${MEDICINE_TYPE_PREFIX}CLEAR_NOTIFY`
}

// Drug Classifications
const DRUG_CLASSIFICATION_PREFIX = 'DRUG_CLASSIFICATION_'
export const DRUG_CLASSIFICATION = {
  LIST_REQUEST: `${DRUG_CLASSIFICATION_PREFIX}LIST_REQUEST`,
  LIST_SUCCESS: `${DRUG_CLASSIFICATION_PREFIX}LIST_SUCCESS`,
  LIST_FAILURE: `${DRUG_CLASSIFICATION_PREFIX}LIST_FAILURE`,
  CREATE_REQUEST: `${DRUG_CLASSIFICATION_PREFIX}CREATE_REQUEST`,
  CREATE_SUCCESS: `${DRUG_CLASSIFICATION_PREFIX}CREATE_SUCCESS`,
  CREATE_FAILURE: `${DRUG_CLASSIFICATION_PREFIX}CREATE_FAILURE`,
  UPDATE_REQUEST: `${DRUG_CLASSIFICATION_PREFIX}UPDATE_REQUEST`,
  UPDATE_SUCCESS: `${DRUG_CLASSIFICATION_PREFIX}UPDATE_SUCCESS`,
  UPDATE_FAILURE: `${DRUG_CLASSIFICATION_PREFIX}UPDATE_FAILURE`,
  DELETE_REQUEST: `${DRUG_CLASSIFICATION_PREFIX}DELETE_REQUEST`,
  DELETE_SUCCESS: `${DRUG_CLASSIFICATION_PREFIX}DELETE_SUCCESS`,
  DELETE_FAILURE: `${DRUG_CLASSIFICATION_PREFIX}DELETE_FAILURE`,
  CLEAR_NOTIFY: `${DRUG_CLASSIFICATION_PREFIX}CLEAR_NOTIFY`
}

// Dosage Forms
const DOSAGE_FORM_PREFIX = 'DOSAGE_FORM_'
export const DOSAGE_FORM = {
  LIST_REQUEST: `${DOSAGE_FORM_PREFIX}LIST_REQUEST`,
  LIST_SUCCESS: `${DOSAGE_FORM_PREFIX}LIST_SUCCESS`,
  LIST_FAILURE: `${DOSAGE_FORM_PREFIX}LIST_FAILURE`,
  CREATE_REQUEST: `${DOSAGE_FORM_PREFIX}CREATE_REQUEST`,
  CREATE_SUCCESS: `${DOSAGE_FORM_PREFIX}CREATE_SUCCESS`,
  CREATE_FAILURE: `${DOSAGE_FORM_PREFIX}CREATE_FAILURE`,
  UPDATE_REQUEST: `${DOSAGE_FORM_PREFIX}UPDATE_REQUEST`,
  UPDATE_SUCCESS: `${DOSAGE_FORM_PREFIX}UPDATE_SUCCESS`,
  UPDATE_FAILURE: `${DOSAGE_FORM_PREFIX}UPDATE_FAILURE`,
  DELETE_REQUEST: `${DOSAGE_FORM_PREFIX}DELETE_REQUEST`,
  DELETE_SUCCESS: `${DOSAGE_FORM_PREFIX}DELETE_SUCCESS`,
  DELETE_FAILURE: `${DOSAGE_FORM_PREFIX}DELETE_FAILURE`,
  CLEAR_NOTIFY: `${DOSAGE_FORM_PREFIX}CLEAR_NOTIFY`
}
